import { forwardRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { BasicRichTextEditor } from 'components/WYSIWYG';
import { TextSpan } from 'app/typography';
import {
  ConnectEmailAlert,
  StyledSelect,
  StyledInput,
  StyledLabel,
  CenteredLoader,
} from './styles';
import { useIntegratedInbox } from 'hooks/useIntegratedInbox';

export const EmailTemplater = forwardRef(
  (
    {
      inbox = null,
      subject = '',
      body = '',
      onChange,
      disabled,
      enabledResize,
      ...others
    },
    ref
  ) => {
    const { t } = useTranslation();

    const { accountSelectOptions, isLoadingAccounts } =
      useIntegratedInbox(false);

    useEffect(() => {
      if (accountSelectOptions.length && !inbox) {
        onChange('inbox', accountSelectOptions[0]);
      }
    }, [onChange, accountSelectOptions, inbox]);

    if (isLoadingAccounts) {
      return <CenteredLoader loading />;
    }

    return (
      <>
        {!accountSelectOptions.length && (
          <ConnectEmailAlert>
            {t('Please')}{' '}
            <a target="_blank" href="/account">
              {t('connect at least 1 inbox')}
            </a>{' '}
            {t('first in order to use this feature.')}
          </ConnectEmailAlert>
        )}
        <StyledSelect
          fullWidth
          // Prevent label appearing disabled when field is disabled
          label={
            <TextSpan weight="bold" style={{ fontSize: 'inherit' }}>
              {t('From (Connected Inbox)')}
            </TextSpan>
          }
          placeholder={t('Choose Connected Inbox')}
          value={inbox}
          options={accountSelectOptions}
          onChange={(val) => onChange('inbox', val)}
          disabled={disabled || !accountSelectOptions.length}
        />
        <StyledInput
          fullWidth
          placeholder={t('Enter Subject Line')}
          label={t('Subject Line')}
          value={subject}
          onChange={(val) => onChange('subject', val)}
          disabled={disabled}
        />
        <StyledLabel>{t('Enter Message')}</StyledLabel>
        <BasicRichTextEditor
          enableAI
          enableLinks
          textLinkOptions={[
            {
              label: t('Contact Record Link'),
              href: '{{ contact.link_url }}',
            },
          ]}
          ref={ref}
          initialValue={body}
          onChange={({ editor }) => onChange('body', editor.getHTML())}
          disabled={disabled}
          enabledResize={enabledResize && !disabled}
          {...others}
        />
      </>
    );
  }
);
